import { GRID_COLOR, GRID_COLOR_STRONG } from '../utils/constants.js';

/**
 * Overlay that draws the tile grid.
 */
export class GridRenderer {
  render(ctx, state, viewport) {
    if (!state.get('showGrid')) return;

    const mapW = state.get('mapWidth');
    const mapH = state.get('mapHeight');
    const tileW = state.get('tileWidth');
    const tileH = state.get('tileHeight');
    const totalW = mapW * tileW;
    const totalH = mapH * tileH;

    // Cull to visible tile range (with 1-tile padding)
    const b = viewport.tileBounds || { minTileX: 0, minTileY: 0, maxTileX: mapW, maxTileY: mapH };
    const xStart = Math.max(0, b.minTileX);
    const xEnd = Math.min(mapW, b.maxTileX + 1);
    const yStart = Math.max(0, b.minTileY);
    const yEnd = Math.min(mapH, b.maxTileY + 1);

    const top = yStart * tileH;
    const bottom = yEnd * tileH;
    const left = xStart * tileW;
    const right = xEnd * tileW;

    ctx.strokeStyle = GRID_COLOR;
    ctx.lineWidth = 0.5;

    ctx.beginPath();
    for (let x = xStart; x <= xEnd; x++) {
      if (x % 10 !== 0) {
        ctx.moveTo(x * tileW, top);
        ctx.lineTo(x * tileW, bottom);
      }
    }
    for (let y = yStart; y <= yEnd; y++) {
      if (y % 10 !== 0) {
        ctx.moveTo(left, y * tileH);
        ctx.lineTo(right, y * tileH);
      }
    }
    ctx.stroke();

    // Strong grid lines every 10 tiles (culled)
    ctx.strokeStyle = GRID_COLOR_STRONG;
    ctx.lineWidth = 1;
    ctx.beginPath();
    const x10Start = Math.floor(xStart / 10) * 10;
    const y10Start = Math.floor(yStart / 10) * 10;
    for (let x = x10Start; x <= xEnd; x += 10) {
      if (x >= xStart) {
        ctx.moveTo(x * tileW, top);
        ctx.lineTo(x * tileW, bottom);
      }
    }
    for (let y = y10Start; y <= yEnd; y += 10) {
      if (y >= yStart) {
        ctx.moveTo(left, y * tileH);
        ctx.lineTo(right, y * tileH);
      }
    }
    ctx.stroke();

    // Map border
    ctx.strokeStyle = '#ffffff44';
    ctx.lineWidth = 2;
    ctx.strokeRect(0, 0, totalW, totalH);
  }
}
